// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"41586111","455":"d31ea935","488":"42158a46"}[chunkId] + ".chunk.js";
};